"use client";

import { ReactNode } from "react";
import { CookiesProvider } from "react-cookie";

export default function ClientCookiesProvider({ children }: { children: ReactNode }) {
  return <CookiesProvider defaultSetOptions={{ path: "/", maxAge: 60 * 60 * 24 * 30 }}>{children}</CookiesProvider>;
}
